import { api } from "./api";

const SESSION_KEY = "kw_geo_tracked";

/**
 * Detect visitor country/region via a free public API and POST to our backend.
 * Only runs once per browser session to stay under free-tier limits.
 */
export async function trackVisitOnce() {
    try {
        if (sessionStorage.getItem(SESSION_KEY)) return;
        sessionStorage.setItem(SESSION_KEY, "1");
    } catch {
        /* sessionStorage unavailable — still try once */
    }
    try {
        const res = await fetch("https://ipapi.co/json/", { cache: "no-store" });
        if (!res.ok) return;
        const d = await res.json();
        await api.post("/track/visit", {
            country: d.country_name || d.country || "Unknown",
            country_code: d.country_code || d.country || "",
            region: d.region || d.region_code || "",
            city: d.city || "",
        });
    } catch {
        // Geo lookup is best-effort — ignore failures so the shop still works.
    }
}
